module.exports = __webpack_public_path__ + "static/assets/a6d4dfc6cc3c3f41364cd5674074a9c3.svg";